export default "__VITE_ASSET__L83xNDbn__"